module.exports = __webpack_public_path__ + "da7524f5fb07d1df2e4e11011d79141e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/game-controller.png
// module id = 977
// module chunks = 0